/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import { CITIZEN_ROLES } from '@/config/citizenRoles'

export default () => ({
    forms: null,
    form: null,
    types: null,
    formStatuses: {},
    formsConfig: {
        include: "statuses.actions",
        sort: 'id',
        sortDirection: 'desc',
        page: 1,
        filters: {}
    },

    newForm: {
        fr: {
            name: null,
            description: null,
        },
        en: {
            name: null,
            description: null,
        },
        form_type_id: null,
        available_offline: 0,
        contribution: false,
        citizen_roles: [...CITIZEN_ROLES],
        racis:[],
        // racis: {
        //     responsible: [],
        //     accountable: [],
        //     consulted: [],
        //     informed: [],
        // },
        steps: null
    }

    ,

    defaultForm: {
        fr: {
            name: null,
            description: null,
        },
        en: {
            name: null,
            description: null,
        },
        form_type_id: null,
        available_offline: 0,
        contribution: false,
        citizen_roles: [...CITIZEN_ROLES],
        racis:[],
        // racis: {
        //     responsible: [],
        //     accountable: [],
        //     consulted: [],
        //     informed: [],
        // },
        steps: null
    }
});
